import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyDviCXqL1Od9oE2rwp9tO9_6_ZQ7Xwkyk0",
  authDomain: "confes-app-9e54c.firebaseapp.com",
  projectId: "confes-app-9e54c",
  storageBucket: "confes-app-9e54c.firebasestorage.app",
  messagingSenderId: "712422890105",
  appId: "1:712422890105:web:422ddaecbbdf7d6ca692a8",
}

const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)
export const auth = getAuth(app)